<span [class]="'badge badge--' + variant()" [style.text-transform]="textCase()">
  {{ label() }}
</span>
